<template>
    <div class="base-download" :class="{ 'download-sp': $store.state.screen == 1 }">
        <div class="down-tips-text">
            下载最新焕游APP可使用快捷登录
        </div>

        <div v-if="!isDownload" class="btns-box">
            <div @click="back" class="btn disabled">暂不下载</div>
            <div @click="toDownload" class="btn">下载焕游</div>
        </div>
        <div v-else class="progress_box">
            <div class="progress_container">
                <div :style="{ left: (progress - 100) + '%' }" class="progress_line"></div>
            </div>
            <div class="progress_text">
                已下载{{ progress }}%
            </div>
            <div class="btn-flex-center">
                <div @click="cancelDownload" class="btn-cancel">取消</div>
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg="msg" v-if="msg" />
        </transition>
    </div>
</template>

<script>
import TheTips from "@/components/TheTips";

export default {
    components:{
        TheTips
    },
    data() {
        return {
            isDownload: false,
            progress: 0,
            msg:'',
            downloadUrl:''
        }
    },
    methods: {
        back() {
            this.$router.back()
        },
        cancelDownload() {// 取消下载
            this.isDownload = false
            this.process = 0
            if (process.env.NODE_ENV == 'development') return
            window.Android.cancelDownload()
        },
        toDownload() {// 点击前往下载
            if(this.downloadUrl){
                this.isDownload = true
                window.Android.startDownLoadHY(this.downloadUrl)
            }else{
                this.msg = '获取下载链接失败'
                setTimeout(()=>{
                    this.msg = ''
                },1500)
            }
        },
        finishDownLoadHY({ success, filePath, errorMsg }) {// 下载完成通知
            if (success) {
                window.Android.installDownLoadHY(filePath)
            } else {
                this.cancelDownload()
                this.msg = errorMsg
                setTimeout(()=>{
                    this.msg = ''
                },1500)
            }
        },
        updateProgress({ progress }) {// 下载进度更新
            this.progress = progress
        },
        installResult({success,message}) {// 通知结果
            if (success) {
                this.msg = 'installResult success->'+success
                this.$router.back()
            } else {
                this.msg = message
                setTimeout(()=>{
                    this.msg = ''
                },1500)
                this.isDownload = false
                this.progress = 0
            }
        },
    },
    created() {
        window.notifyHYDownloadProgress = this.updateProgress// 下载进度通知
        window.finishDownLoadHY = this.finishDownLoadHY// 下载完成通知
        window.installResult = this.installResult// 安装完成
        let channel = 1
        let data = sessionStorage.getItem('loginData')
        if(data){
            data = JSON.parse(data)
            if(data.channel){
                channel = data.channel
            }
        }
        this.$axios.get(`https://box.gameschain.pro/index.php?g=api&m=game&a=checkClient&system=1&channel=${channel}&version=v0.01`).then(res=>{
            if(res.data.status==0){
                this.downloadUrl = res.data.data.url
            }
        })
    }
}
</script>

<style lang="scss" scoped>
$color: #FF6B21; // 主体颜色

.base-download {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 760px;
    height: 785px;
    overflow: hidden;
    border-radius: 50px;
    background: url('../../../static/images/bg-down.png') 0 0/760px 405px no-repeat, rgba(0, 0, 0, 0.8);
    padding-top: 476px;

    .down-tips-text {
        text-align: center;
        line-height: 38px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 38px;
        color: #FFFFFF;
    }

    .btns-box {
        margin-top: 63px;
        padding: 0 38px;
        display: flex;
        justify-content: space-between;

        .btn {
            width: 320px;
            height: 101px;
            line-height: 101px;
            text-align: center;
            background: $color;
            border-radius: 13px;
            font-size: 35px;
        }

        .disabled {
            background: rgba($color, 0.5);
        }
    }

    .progress_box {
        margin-top: 89px;
        --line-height: 25px;

        .progress_container {
            margin: 0 auto;
            width: 684px;
            height: var(--line-height);
            border-radius: var(--line-height);
            overflow: hidden;
            position: relative;
            background: rgba(#FFFFFF, 0.2);

            .progress_line {
                position: absolute;
                top: 0;
                width: 100%;
                height: var(--line-height);
                border-radius: var(--line-height);
                background: $color;
            }
        }

        .progress_text {
            margin-top: 17px;
            padding-left: 50px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 27px;
            line-height: 27px;
            height: 27px;
            color: rgba(#FFFFFF, 0.5);
        }

        .btn-flex-center {
            margin-top: 39px;
            display: flex;
            justify-content: center;

            .btn-cancel {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 35px;
                line-height: 35px;
                color: #FFFFFF;
            }
        }
    }
}

.download-sp {
    width: 1520px;
    height: 1570px;
    overflow: hidden;
    border-radius: 50px;
    background: url('../../../static/images/bg-down.png') 0 0/1520px 810px no-repeat, rgba(0, 0, 0, 0.8);
    padding-top: 962px;

    .down-tips-text {
        text-align: center;
        line-height: 76px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 76px;
        color: #FFFFFF;
    }

    .btns-box {
        margin-top: 126px;
        padding: 0 76px;
        display: flex;
        justify-content: space-between;

        .btn {
            width: 658px;
            height: 202px;
            line-height: 202px;
            text-align: center;
            background: $color;
            border-radius: 26px;
            font-size: 70px;
        }

        .disabled {
            background: rgba($color, 0.5);
        }
    }

    .progress_box {
        margin-top: 179px;

        .progress_container {
            margin: 0 auto;
            width: 1368px;
            height: 50px;
            border-radius: 50px;
            overflow: hidden;
            position: relative;
            background: rgba(#FFFFFF, 0.2);

            .progress_line {
                position: absolute;
                top: 0;
                width: 100%;
                height: 50px;
                border-radius: 50px;
                background: $color;
            }
        }

        .progress_text {
            margin-top: 25px;
            padding-left: 100px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 55px;
            line-height: 55px;
            height: 55px;
            color: rgba(#FFFFFF, 0.5);
        }

        .btn-flex-center {
            margin-top: 78px;
            display: flex;
            justify-content: center;

            .btn-cancel {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 70px;
                line-height: 70px;
                color: #FFFFFF;
            }
        }
    }
}
</style>